import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./ConfirmDeactivateModal.css";

const CancelOrderModal = ({ show, onClose, onConfirm, reason, setReason }) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="custom-modal"
    >
      <Modal.Body>
        <div className="text-center">
           <div className="warning-icon mb-3">
          <img
            src="https://cdn-icons-png.flaticon.com/512/564/564619.png"
            alt="warning"
            width={40}
          />
        </div>
          <p className="cancel-message fw-semibold mt-3">
            {t("admin.orders.cancelConfirm")}
          </p>

          <Form.Control
            type="text"
            placeholder={t("admin.orders.reasonForCancellation")}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="cancel-reason-input"
            required
          />

 <div className="d-flex justify-content-end gap-3 mt-4">
          <Button variant="light" onClick={onClose} className="btn-no mr-4">
            {t("common.no")}
          </Button>
          <Button  onClick={onConfirm}
              disabled={!reason.trim()} variant="primary"  className="btn-yes">
            {t("common.yes")}
          </Button>
        </div>
        
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CancelOrderModal;
